export interface Topic {
  id: string;
  rank: number;
  title: string;
  category: string;
  heat: number;
  trend: "up" | "down" | "new" | "flat";
  trendValue: number;
  tags: string[];
  summary: string;
  cover: string;
  comments: number;
  updatedAt: string;
  live: boolean;
}

export const topics: Topic[] = [
  {
    id: "drama-finale-backlash",
    rank: 1,
    title: "热播古装剧大结局口碑两极，观众直呼意难平",
    category: "film",
    heat: 1286000,
    trend: "up",
    trendValue: 326,
    tags: ["剧集", "大结局", "口碑"],
    summary:
      "开播即登顶讨论量的古装长剧昨日收官，结局的改写处理让围观网友分成两派，相关话题在榜单上持续走高。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20spotlight%20beams%20shining%20over%20a%20vintage%20film%20reel%20and%20old%20cinema%20seats%2C%20dramatic%20empty%20stage%20with%20glowing%20dust%2C%20editorial%20cinematic%20photography%2C%20rich%20orange%20and%20gold%20tones%2C%20soft%20grain%2C%20abstract%20storytelling%20atmosphere&width=1200&height=675&seq=cg-rank-01&orientation=landscape",
    comments: 8642,
    updatedAt: "12 分钟前",
    live: true,
  },
  {
    id: "variety-name-scene",
    rank: 2,
    title: "综艺录制的“名场面”片段流出，嘉宾反应被反复回放",
    category: "film",
    heat: 964000,
    trend: "up",
    trendValue: 188,
    tags: ["综艺", "名场面", "剪辑"],
    summary:
      "一段未播出的录制花絮在短视频平台快速扩散，网友围绕剪辑节奏与临场反应展开大讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20television%20studio%20stage%20with%20colorful%20panel%20lights%20and%20empty%20host%20desk%2C%20warm%20amber%20and%20coral%20glow%2C%20abstract%20broadcast%20set%20without%20people%2C%20editorial%20photography%2C%20cinematic%20soft%20focus&width=1200&height=675&seq=cg-rank-02&orientation=landscape",
    comments: 6421,
    updatedAt: "24 分钟前",
    live: false,
  },
  {
    id: "livestream-comeback",
    rank: 3,
    title: "头部主播久违开播，直播间的“回归名场面”冲上榜单",
    category: "star",
    heat: 872000,
    trend: "up",
    trendValue: 142,
    tags: ["直播", "回归", "人气"],
    summary:
      "停播一段时间后重新开播，开播数据与互动氛围都引来大量围观，讨论集中在直播内容的新变化。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20modern%20live%20streaming%20setup%20with%20ring%20light%20and%20microphone%20on%20warm%20wooden%20desk%2C%20soft%20orange%20ambient%20glow%2C%20cozy%20studio%2C%20editorial%20product%20photography%2C%20no%20people%2C%20clean%20composition&width=1200&height=675&seq=cg-rank-03&orientation=landscape",
    comments: 5310,
    updatedAt: "41 分钟前",
    live: true,
  },
  {
    id: "idol-airport-outfit",
    rank: 4,
    title: "艺人机场造型细节被放大解读，穿搭讨论持续发酵",
    category: "ent",
    heat: 795000,
    trend: "flat",
    trendValue: 12,
    tags: ["穿搭", "造型", "路透"],
    summary:
      "一组路透图让造型话题再次被翻出，网友从配色到配饰逐帧分析，讨论热度保持平稳。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20fashion%20flat%20lay%20of%20warm%20autumn%20coat%2C%20sunglasses%20and%20leather%20bag%20on%20cream%20backdrop%2C%20styled%20editorial%20still%20life%2C%20terracotta%20and%20amber%20tones%2C%20soft%20natural%20light&width=1200&height=675&seq=cg-rank-04&orientation=landscape",
    comments: 4102,
    updatedAt: "1 小时前",
    live: false,
  },
  {
    id: "new-drama-premiere",
    rank: 5,
    title: "新剧开播首集评分出炉，节奏与选角成讨论焦点",
    category: "film",
    heat: 731000,
    trend: "new",
    trendValue: 0,
    tags: ["开播", "评分", "选角"],
    summary:
      "备受期待的都市剧首播，首集节奏与角色塑造引发分化评价，站内短评数量快速攀升。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinema%20marquee%20lights%20glowing%20warm%20orange%20against%20dusk%20sky%2C%20empty%20theater%20entrance%20with%20abstract%20bokeh%2C%20editorial%20cinematic%20photography%2C%20cozy%20evening%20mood%2C%20no%20readable%20text&width=1200&height=675&seq=cg-rank-05&orientation=landscape",
    comments: 3877,
    updatedAt: "1 小时前",
    live: false,
  },
  {
    id: "song-cover-viral",
    rank: 6,
    title: "翻唱片段意外走红，原曲评论区被“考古”刷屏",
    category: "ent",
    heat: 668000,
    trend: "up",
    trendValue: 96,
    tags: ["音乐", "翻唱", "出圈"],
    summary:
      "一段翻唱在现场版被转发后迅速传播，带动原曲重新回到热门歌单，网友开始集体回忆。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20microphone%20on%20wooden%20stage%20with%20warm%20golden%20bokeh%20lights%2C%20empty%20concert%20atmosphere%2C%20abstract%20music%20scene%20without%20people%2C%20editorial%20photography%2C%20rich%20amber%20and%20rose%20tones&width=1200&height=675&seq=cg-rank-06&orientation=landscape",
    comments: 2988,
    updatedAt: "2 小时前",
    live: false,
  },
  {
    id: "city-food-trend",
    rank: 7,
    title: "街头小店凭一口“隐藏菜单”排队，探店视频带火整条街",
    category: "life",
    heat: 512000,
    trend: "up",
    trendValue: 74,
    tags: ["探店", "美食", "本地"],
    summary:
      "一条探店短视频让街边小店排起长队，网友一边晒菜单一边讨论是否值得专程前往。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20street%20food%20stall%20with%20steaming%20bowls%20and%20warm%20lantern%20light%20at%20dusk%2C%20rustic%20night%20market%20atmosphere%2C%20no%20people%2C%20editorial%20food%20photography%2C%20warm%20orange%20tones%2C%20inviting%20mood&width=1200&height=675&seq=cg-rank-07&orientation=landscape",
    comments: 2210,
    updatedAt: "3 小时前",
    live: false,
  },
  {
    id: "public-topic-debate",
    rank: 8,
    title: "公共话题引发理性讨论，网友从不同角度给出看法",
    category: "society",
    heat: 468000,
    trend: "down",
    trendValue: 38,
    tags: ["话题", "讨论", "观点"],
    summary:
      "一个与日常生活相关的公共话题被广泛转述，讨论逐渐从情绪转向具体建议，热度小幅回落。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20conversation%20concept%20with%20empty%20round%20table%20and%20cups%2C%20soft%20amber%20window%20light%2C%20minimal%20cozy%20interior%2C%20editorial%20still%20life%2C%20no%20people%2C%20calm%20thoughtful%20mood&width=1200&height=675&seq=cg-rank-08&orientation=landscape",
    comments: 1876,
    updatedAt: "4 小时前",
    live: false,
  },
  {
    id: "fitness-routine-viral",
    rank: 9,
    title: "达人分享的自律作息表被疯转，评论区却吵起了另一半",
    category: "star",
    heat: 402000,
    trend: "down",
    trendValue: 22,
    tags: ["自律", "作息", "争议"],
    summary:
      "一份看似完美的作息计划引起模仿热潮，也有不少人质疑其可执行性，形成正反两方讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20morning%20routine%20still%20life%20with%20notebook%2C%20green%20plant%20and%20cup%20on%20warm%20wooden%20desk%2C%20soft%20sunlight%2C%20editorial%20lifestyle%20photography%2C%20amber%20and%20sage%20tones%2C%20no%20people&width=1200&height=675&seq=cg-rank-09&orientation=landscape",
    comments: 1642,
    updatedAt: "5 小时前",
    live: false,
  },
  {
    id: "award-season-talk",
    rank: 10,
    title: "颁奖季预热开启，入围名单公布的瞬间就是热点",
    category: "ent",
    heat: 356000,
    trend: "new",
    trendValue: 0,
    tags: ["颁奖", "入围", "盘点"],
    summary:
      "年度奖项入围名单陆续放出，网友立刻开始做预测与盘点，榜单尾部话题迅速补位。",
    cover:
      "https://readdy.ai/api/search-image?query=Golden%20trophy%20abstract%20shape%20on%20warm%20cream%20stage%20with%20soft%20spotlight%2C%20empty%20awards%20hall%20without%20people%2C%20editorial%20photography%2C%20elegant%20amber%20and%20terracotta%20palette&width=1200&height=675&seq=cg-rank-10&orientation=landscape",
    comments: 1210,
    updatedAt: "6 小时前",
    live: false,
  },
];

export const topicMap: Record<string, Topic> = topics.reduce(
  (acc, item) => {
    acc[item.id] = item;
    return acc;
  },
  {} as Record<string, Topic>,
);

export const formatHeat = (value: number): string => {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return `${value}`;
};